<template>
  <PageView>
    <a-card>
      <div>
        <a-space>
          <a-space>
            分站ID:
            <a-input
              v-model="queryParam.oemUid"
              style="width: 220px"
              placeholder="分站ID"
            />
          </a-space>
          <a-space>
            目标用户ID:
            <a-input
              v-model="queryParam.uid"
              style="width: 220px"
              placeholder="目标用户ID"
            />
          </a-space>
          <a-button type="primary" @click="btnSearch">搜索</a-button>
          <a-button @click="reset">重置</a-button>
          <a-button type="primary" @click="openInsert">新增调价</a-button>
        </a-space>
      </div>
      <s-table
        style="margin-top: 10px"
        ref="table"
        size="small"
        :columns="columns"
        :data="dataSource"
      >
        <template slot="enable" slot-scope="text, record, index">
          <span :style="{ color: text ? 'green' : undefined }">{{
            text ? "启用" : "否"
          }}</span>
        </template>
        <template slot="operation" slot-scope="text, record, index">
          <a-popconfirm
            title="确定删除该调价?"
            ok-text="确定"
            cancel-text="取消"
            @confirm="removeItem(record.id)"
          >
            <a style="color: red">删除</a>
          </a-popconfirm>
          <a style="margin-left: 10px" @click="update(record)">修改</a>
        </template>
      </s-table>
    </a-card>
    <a-modal
      title="调价编辑/新增"
      :visible="visible"
      @cancel="cancel"
      @ok="confirm"
    >
      <div
        v-if="isOem"
        style="margin-left: 100px; display: flex; align-items: center; gap: 16px; margin-bottom: 20px"
      >
        <a-input v-model="mobile" placeholder="根据手机号查找用户ID" />
        <a-button :loading="mobileLoading" @click="searchMobile"
          >搜索并自动填充</a-button
        >
      </div>
      <a-form-model
        ref="form"
        layout="horizontal"
        :model="edit"
        v-bind="formCol"
        :rules="rules"
      >
        <a-form-model-item v-if="admin" label="分站ID" prop="oemUid">
          <a-input v-model="edit.oemUid" placeholder="分站ID" />
        </a-form-model-item>
        <a-form-model-item label="目标用户ID" prop="uid">
          <a-input v-model="edit.uid" placeholder="目标用户ID" />
        </a-form-model-item>
        <a-form-model-item label="仓库" prop="addressId">
          <a-select
            v-model="edit.addressId"
            :options="storeOptions"
            placeholder="仓库"
            @change="() => addressChange('change')"
          />
        </a-form-model-item>
        <a-form-model-item label="调价类型">
          <!-- logistics -->
          <a-radio-group v-model="edit.type">
            <a-radio value="logistics">快递</a-radio>
            <a-radio value="goods">商品</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <template v-if="edit.type === 'logistics'">
          <a-form-model-item label="快递">
            <a-select
              v-model="edit.logisticsId"
              :options="logisticsList"
              placeholder="快递"
            />
          </a-form-model-item>
          <a-form-model-item label="快递调价">
            <a-input-number
              v-model="edit.logisticsPart"
              :min="0"
              :step="0.01"
            />
          </a-form-model-item>
        </template>
        <template v-else>
          <a-form-model-item label="商品">
            <a-select
              v-model="edit.goodsId"
              placeholder="商品"
              option-label-prop="label"
            >
              <a-select-option
                v-for="goods in goodsList"
                :key="goods.id"
                :label="goods.name"
                :value="goods.id"
              >
                <div>
                  <img :src="goods.picture" style="width: 30px; height: 30px" />
                  {{ goods.name }}(￥{{ goods.price }})
                </div>
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="商品调价">
            <a-input-number v-model="edit.goodsPart" :step="0.01" />
          </a-form-model-item>
        </template>
        <a-form-model-item label="是否启用">
          <a-switch
            v-model:checked="edit.enable"
            checked-children="启用"
            un-checked-children="否"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </PageView>
</template>
<script>
import { STable } from "@/components";
import { PageView } from "@/layouts";

import {
  queryOemPriceList,
  removeOemPrice,
  goodsListAll,
  addressLogisticsListByUser,
  updateOemPrice,
  insertOemPrice,
  addressList,
  accountList
} from "@/api";
import { formatDate, platformType } from "@/utils/util";

export default {
  components: {
    STable,
    PageView
  },
  data() {
    return {
      queryParam: {},
      formCol: { labelCol: { span: 5 }, wrapperCol: { span: 19 } },
      rules: {
        oemUid: { required: true, message: "请填写分站ID", trigger: "blur" },
        uid: { required: true, message: "请填写目标用户ID", trigger: "blur" },
        addressId: { required: true, message: "请选择仓库", trigger: "blur" }
      },
      columns: [
        { title: "分站ID", dataIndex: "oemUid" },
        {
          title: "目标用户ID",
          dataIndex: "uid"
        },
        { title: "快递ID", dataIndex: "logisticsId" },
        { title: "快递调价", dataIndex: "logisticsPart" },
        { title: "商品Id", dataIndex: "goodsId" },
        { title: "商品调价", dataIndex: "goodsPart" },
        {
          title: "是否启用",
          dataIndex: "enable",
          scopedSlots: { customRender: "enable" }
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          customRender: formatDate
        },
        {
          title: "更新时间",
          dataIndex: "updateTime",
          customRender: formatDate
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" }
        }
      ],
      dataSource: parameter => {
        return queryOemPriceList(
          Object.assign(parameter, this.queryParam, { admin: this.admin })
        ).then(result => {
          return result.data;
        });
      },
      edit: {}, // 编辑内容
      visible: false, // 编辑弹窗,
      tempGoodsList: [],
      goodsList: [],
      tempLogisticsList: [],
      logisticsList: [],
      storeOptions: [],
      mobileLoading: false,
      mobile: undefined
    };
  },
  computed: {
    admin() {
      return this.$route.name === "adminPriceControl";
    },
    isOem() {
      return this.$route.name === "oemPriceControl";
    }
  },
  created() {
    this.getStoreOptions();
  },
  methods: {
    async getGoodsList(uid) {
      this.goodsList = [];
      const res = await goodsListAll({
        pageSize: 1000,
        uid
      });
      if (res.success) {
        this.goodsList = JSON.parse(JSON.stringify(res.data.list));
      }
    },
    async getLogisticsList(uid) {
      this.logisticsList = [];
      const res = await addressLogisticsListByUser(uid);
      if (res.success) {
        const temp = res.data.map(val => ({
          label: val.name + `(${platformType[val.platform]})`,
          value: val.id,
          uid: val.uid
        }));
        this.logisticsList = JSON.parse(JSON.stringify(temp));
      }
    },
    async getStoreOptions() {
      const res = await addressList();
      if (res.success) {
        this.storeOptions = res.data.map(val => ({
          label: val.name,
          value: val.id,
          uid: val.uid
        }));
      }
    },
    async removeItem(id) {
      const res = await removeOemPrice(id);
      if (res.success) {
        this.$refs.table.refresh(false);
      }
    },
    async searchMobile() {
      if (!this.mobile) return this.$message.error("请填写用户手机号码！");
      this.mobileLoading = true;
      const res = await accountList("oem", {
        pageSize: 1,
        mobile: this.mobile
      });
      this.mobileLoading = false;
      if (res.success && res.data.list.length) {
        this.$set(this.edit, "uid", res.data.list[0].id);
        this.mobile = undefined;
        this.$message.success("已填充!");
      } else {
        this.$message.info("该手机号无绑定的用户！");
      }
    },
    btnSearch() {
      this.$refs.table.refresh(true);
    },
    reset() {
      this.queryParam = {};
      this.$refs.table.refresh(true);
    },
    openInsert() {
      this.edit = { type: "logistics" };
      this.visible = true;
    },
    addressChange(type) {
      if (type) {
        this.$set(this.edit, "goodsId", undefined);
        this.$set(this.edit, "logisticsId", undefined);
      }
      const find = this.storeOptions.find(
        val => val.value === this.edit.addressId
      );
      if (find) {
        this.getGoodsList(find.uid);
        this.getLogisticsList(find.uid);
      }
    },
    cancel() {
      this.visible = false;
      this.edit = {};
      this.mobile = undefined;
    },
    update(record) {
      const type = record.logisticsId ? "logistics" : "goods";
      this.edit = JSON.parse(JSON.stringify(record));
      this.$set(this.edit, "type", type);
      this.addressChange();
      this.visible = true;
    },
    async confirm() {
      const checkRes = await new Promise(resolve => {
        this.$refs.form.validate(e => {
          resolve(!!e);
        });
      });
      if (!checkRes) return;
      const data = JSON.parse(JSON.stringify(this.edit));
      if (data.type === "logistics") {
        delete data.goodsId;
        delete data.goodsPart;
        if (!data.logisticsId) return this.$message.error("请填写快递信息");
        if (data.logisticsPart === undefined)
          return this.$message.error("请填写快递调价");
      } else {
        delete data.logisticsId;
        delete data.logisticsPart;
        if (!data.goodsId) return this.$message.error("请填写商品信息");
        if (data.goodsPart === undefined)
          return this.$message.error("请填写商品调价");
      }
      delete data.type;
      data.admin = this.admin;
      const methods = data.id ? updateOemPrice : insertOemPrice;
      const res = await methods(data);
      if (res.success) {
        this.$message.success(`操作成功`);
        this.cancel();
        this.$refs.table.refresh(false);
      } else {
        this.$message.error(`操作失败, ${res.msg}`);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 20px;
}
</style>
